import type { NextSearchParams } from '../../schema/frameworks/entry.js';
import { type ModalTypes, validate } from '../../schema/input/entry.js';

/**
 * Util function to get valid modal type from search params.
 *
 * @param modalTypes the modal types that should be considered valid.
 * @param searchParams Current search params
 * @returns Valid modal type or undefined
 */
export function getValidModal(
  modalTypes: ModalTypes[],
  searchParams: NextSearchParams | URLSearchParams
): ModalTypes | undefined {
  const queryObject: NextSearchParams =
    searchParams instanceof URLSearchParams ? Object.fromEntries(searchParams) : searchParams;

  const { modal: modalQueryValue } = validate.query('modal').parse(queryObject) ?? {};

  return modalTypes.find((type) => type === modalQueryValue);
}
